export const GRAVATAR = "https://gravatar.com/avatar/";

const clean = (email: string) => email.trim().toLowerCase();

/** The Gravatar image of the email; d=blank gives a clear image when the email has none, so the initials show. */
export async function gravatarUrl(email: string, size = 64): Promise<string | null> {
  const address = clean(email);
  if (!address || !globalThis.crypto?.subtle) return null;
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(address));
  const hash = [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${GRAVATAR}${hash}?s=${size}&d=blank`;
}

/** One or two letters: from the name when the account has one, else from the part of the email before the @ and the +. */
export function initials(email: string, name?: string | null): string {
  const source = name?.trim() || clean(email).split("@")[0].split("+")[0];
  const words = source
    .split(/[\s._+-]+/)
    .map((word) => word.replace(/[^\p{L}\p{N}]/gu, ""))
    .filter(Boolean);
  const picked = words.length > 1 ? [words[0], words[words.length - 1]] : words;
  return picked.map((word) => [...word][0]).join("").toUpperCase() || "?";
}

/** A hue from 0 to 359 that is always the same for one email. */
export function avatarHue(email: string): number {
  let hash = 0;
  for (const char of clean(email)) hash = (hash * 31 + (char.codePointAt(0) ?? 0)) >>> 0;
  return hash % 360;
}
